<template>
  <div class="search-filter-container table-info-filter">
    <!-- 진료과목 필터 -->
    <div class="search-filter-row">
      <div class="search-filter-title">진료과목</div>
      <div class="search-filter-content">
        <select class="search-select" v-model="filters.department" @change="handleFilterChange">
          <option :value="MedicalDept.OPH">{{ MedicalDeptText.OPH }}</option>
          <option :value="MedicalDept.DENT">{{ MedicalDeptText.DENT }}</option>
          <option :value="MedicalDept.DERM">{{ MedicalDeptText.DERM }}</option>
          <option :value="MedicalDept.PS">{{ MedicalDeptText.PS }}</option>
          <option :value="MedicalDept.VET_COMMON">{{ MedicalDeptText.VET_COMMON }}</option>
          <option :value="MedicalDept.OS">{{ MedicalDeptText.OS }}</option>
        </select>
      </div>
    </div>
    
    <!-- 사용 여부 필터 -->
    <div class="search-filter-row">
      <div class="search-filter-title">사용 여부</div>
      <div class="search-filter-content">
        <select class="search-select" v-model="filters.useFilter" @change="handleFilterChange">
          <option value="">전체</option>
          <option value="certificate">인증서 사용</option>
          <option value="hospital">병원 예약 사용</option>
        </select>
      </div>
    </div>
    
    <!-- 검색어 필터 -->
    <div class="search-filter-row">
      <div class="search-filter-title">검색어</div>
      <div class="search-filter-content">
        <select class="search-select" v-model="filters.searchFilter">
          <option value="name">카테고리명</option>
        </select>
        <div class="search-input-container">
          <div class="search-icon">
            <img src="../../../assets/img/search.png" alt="검색" width="20" height="20" class="me-2">
          </div>
          <input
            type="text"
            class="search-input-text"
            v-model="filters.condition"
            ref="cdInput"
            placeholder="조건을 입력해주세요."
            autocomplete="off"
            @keyup.enter="search"
            :readonly="!isFocused"
            @focus="isFocused = true"
          />
        </div>
        <button class="search-btn" @click="search">검색</button>
        <button class="init-btn" @click="reset">초기화</button>
      </div>
    </div>
  </div>
</template>

<script>
import { MedicalDept, MedicalDeptText } from "@/utils/enums";

export default {
  name: "CategorySearchFilter",
  props: {
    initialFilters: {
      type: Object,
      default: () => ({
        department: MedicalDept.OPH,
        useFilter: "",
        searchFilter: "name",
        condition: ""
      })
    }
  },
  data() {
    return {
      MedicalDept,
      MedicalDeptText,
      isFocused: false,
      filters: {
        department: this.initialFilters.department,
        useFilter: this.initialFilters.useFilter,
        searchFilter: this.initialFilters.searchFilter,
        condition: this.initialFilters.condition
      }
    };
  },
  methods: {
    handleFilterChange() {
      this.$emit('filter-change', { ...this.filters });
    },
    
    search() {
      this.$emit('search', { ...this.filters });
    },
    
    reset() {
      this.filters = {
        department: MedicalDept.OPH,
        useFilter: "",
        searchFilter: "name",
        condition: ""
      };
      this.$emit('reset', { ...this.filters });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

/* 검색 필터 스타일 */
.search-filter-container {
  background-color: $bg-light;
  border-radius: $border-radius-md;
  padding: $spacing-md;
  margin-bottom: $spacing-lg;
  
  .search-filter-row {
    display: flex;
    align-items: center;
    margin-bottom: $spacing-sm;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .search-filter-title {
      flex: 0 0 120px;
      font-weight: $font-weight-bold;
    }
    
    .search-filter-content {
      flex: 1;
      display: flex;
      align-items: center;
      
      .search-select {
        min-width: 120px;
        height: 38px;
        border: 1px solid $border-color-dark;
        border-radius: $border-radius-sm;
        padding: 0 10px;
        margin-right: $spacing-sm;
        background-color: $bg-white;
      }
      
      .search-input-container {
        display: flex;
        align-items: center;
        border: 1px solid $border-color-dark;
        border-radius: $border-radius-sm;
        padding: 0 $spacing-sm;
        margin-right: $spacing-sm;
        background-color: $bg-white;
        flex: 1;
        max-width: 400px;
        
        .search-input-text {
          border: none;
          outline: none;
          height: 36px;
          flex: 1;
          background-color: transparent;
        }
      }
      
      .search-btn {
        @include button-style(
          $primary-color, 
          $bg-white, 
          $primary-color, 
          $primary-color-hover, 
          $bg-white, 
          $primary-color-hover
        );
        height: 38px;
        margin-right: $spacing-sm;
      }
      
      .init-btn {
        @include button-style(
          $secondary-color, 
          $bg-white, 
          $secondary-color, 
          $secondary-color-hover, 
          $bg-white, 
          $secondary-color-hover
        );
        height: 38px;
        margin-right: $spacing-sm;
      }
    }
  }
}
</style> 